import { type FamilyType, type ResidenceType } from 'types/services/Family'

export function residenceRules(family: FamilyType, attribute: string): boolean {
  if (family.residenceInfo !== undefined) {
    const answer =
      family.residenceInfo[attribute as keyof ResidenceType]?.answer ?? ''
    switch (attribute) {
      case 'drinkableWater':
        if (answer === undefined || String(answer).includes('Sem tratamento'))
          return true
        break

      case 'waterSuply':
        if (answer === undefined) return true
        break

      case 'garbageCollectionFrequency':
        if (answer === undefined || String(answer).includes('Nenhuma vez'))
          return true
        break

      case 'garbageDisposal':
        if (
          String(answer).includes('É queimado ou enterrado na propriedade') ||
          String(answer).includes('É jogado em terreno baldio ou logradouro') ||
          String(answer).includes('É jogado em rio, lago ou mar')
        )
          return true
        break

      case 'formOfLighting':
        if (!String(answer).includes('Elétrica')) return true
        break

      case 'hasBathroom':
        if (answer === false) return true
        break

      case 'paving':
        if (String(answer).includes('Não existe')) return true
        break

      case 'sanitaryDrainage':
        if (
          String(answer).includes('Vala a céu aberto') ||
          String(answer).includes('Direto para um rio, lago ou mar')
        )
          return true
        break

      case 'wallsMaterial':
        if (
          String(answer).includes('Taipa revestida') ||
          String(answer).includes('Taipa não-revestida') ||
          String(answer).includes('Madeira aproveitada') ||
          String(answer).includes('Palha')
        )
          return true
        break

      case 'floorMaterial':
        if (String(answer).includes('Terra')) return true
        break

      default:
        return false
    }
  }
  return false
}
